/*
  共通コード定義
  © 2021 Digital Information Technologies Corporation. All Rights Reserved.
  @author Digital Information Technologies Corporation
  @module src/constants/code.ts
*/

/*
  共通コード定義
  全プロジェクト共通のコード値を定義する。
  @class src:constants:Code
  @constructor
*/
class Code {
  defaults: { [key: string]: any } = {};
  attributes: { [key: string]: any } = {};

  constructor() {
    this.defaults = {
      // 共通
      common: {},
      // 性別
      gender: {
        "0": "男性",
        "1": "女性",
        "2": "未回答",
      },
      // 属性
      attribute: {
        0: "患者",
        1: "患者の家族",
        2: "医療関係者",
        3: "その他",
      },
      randomWelcomeMessage: {
        0: "気になる記事はお気に入りすると便利です♪",
        1: "おすすめ記事をぜひチェックしてみてください",
        // 2: "アンケートにぜひご協力お願いします",
        3: "社会保障制度から活用できる制度をチェック",
        4: "記事のハートを押すといいね！できます",
        5: "関心のあるものはプロフィールでも追加できます",
        6: "気になる記事はありましたか？",
        7: "今日も来てくれてありがとうございます",
        8: "マイレポートで体調記録を確認できます！",
      },
      // 都道府県の地域分け（DPF取得後クライアントでグループ化する用）
      prefectureRegions: [
        { name: "北海道・東北", minCode: 1, maxCode: 7 },
        { name: "関東", minCode: 8, maxCode: 14 },
        { name: "中部・北陸", minCode: 15, maxCode: 24 },
        { name: "関西", minCode: 25, maxCode: 30 },
        { name: "中国・四国", minCode: 31, maxCode: 39 },
        { name: "九州・沖縄", minCode: 40, maxCode: 47 },
      ],
      // プロフィール画面で患者会所属確認
      statusPatientGroupOptions: [
        { value: "1", label: "あり" },
        { value: "0", label: "なし" },
        { value: "2", label: "以前あり" },
        { value: "3", label: "その他" },
      ],
    };
  }
}
const code = new Code();

// プロパティattributesを設定する。
//
// これは、base/modelを継承していた際の名残り。
// クラス内での定義は、プロパティdefaultsを参照できないので、
// クラスの定義外から設定する。
code.attributes = code.defaults;

export default code;
